export const Access = {
  Request: `/access/requests/:objectId`,
};

export const Workspaces = {
  FileNotFound: `/workspaces/files/not-found`,
};